export default class PlanEntrainement {
    id_module;
    id_plan_entrainement;
    actif = false;
    titre = "Plan d'entraînement personnalisé";
    description = "";
    propose = false;
    selected = false;
    prix = 0;
    ids_courses = "";
    ids_courses_codes_disponibles = [];

    constructor(id_module) {
        this.id_module = id_module;
    }

    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    initialize_from_mainstore(data) {
        if (!data) return;
        this.id_plan_entrainement = data.id;
        this.id_module = data.id_module;
        this.actif = data.actif == 1 || data.actif === true;
        this.titre = data.titre || "Plan d'entraînement personnalisé";
        this.prix = parseFloat(data.prix) || 10;
        this.description = data.description || "";
        this.ids_courses = data.ids_courses || "";
        this.ids_courses_codes_disponibles = data.ids_courses_codes_disponibles || [];
    }

    get_eligible_selected_courses(selected_courses) {
        if (!selected_courses || selected_courses.length === 0) {
            return [];
        }

        if (!this.ids_courses || String(this.ids_courses).trim() === "") {
            return selected_courses;
        }

        const allowed_ids = String(this.ids_courses)
            .split(";")
            .map((id) => id.trim())
            .filter((id) => id !== "");

        if (allowed_ids.length === 0) {
            return selected_courses;
        }

        return selected_courses.filter((course) => allowed_ids.includes(String(course.id)));
    }

    is_available_for_selected_courses(selected_courses) {
        return this.get_eligible_selected_courses(selected_courses).length > 0;
    }

    has_available_codes_for_selected_courses(selected_courses) {
        const eligible_courses = this.get_eligible_selected_courses(selected_courses);
        if (eligible_courses.length === 0) {
            return false;
        }

        const available_course_ids = (this.ids_courses_codes_disponibles || []).map(String);
        return eligible_courses.some((course) => available_course_ids.includes(String(course.id)));
    }

    apply_course_filter(selected_courses) {
        if (!this.is_available_for_selected_courses(selected_courses)
            || !this.has_available_codes_for_selected_courses(selected_courses)) {
            this.set_propose(false);
            this.set_selected(false);
        }
    }

    update_cart() {
        let cart = { prix: 0, nb_articles: 0 };
        if (this.selected && this.propose) {
            cart.prix = this.prix;
            cart.nb_articles = 1;
        }
        this.cart = cart;
        return cart;
    }

    set_propose(propose) {
        this.propose = propose;
    }

    set_selected(selected) {
        this.selected = selected;
    }

    set_prix(prix) {
        this.prix = prix;
    }
}
